export default __webpack_public_path__ + "static/media/cornerCabinet.8be3fbc2.png";